import { useTranslation } from 'react-i18next';

import { buttonClassName, CenteredPage, LanguageSwitcher, Logo } from '@rootsight/ui';

/** The error situations this SPA renders for the whole product. */
export type ErrorKind = 'notFound' | 'forbidden' | 'server' | 'session';

/**
 * ErrorPage is reached either by a client-side route or by Traefik, which
 * serves this SPA for unauthenticated and failed requests. Keeping these
 * pages out of the console bundle means they still render when the
 * authenticated app cannot be loaded at all.
 *
 * Every error page has one way forward, as a primary button: a page that
 * only explains leaves the operator stuck.
 */
export function ErrorPage({ kind }: { kind: ErrorKind }) {
  const { t } = useTranslation(['auth', 'common']);

  return (
    <CenteredPage
      brand={<Logo name={t('appName', { ns: 'common' })} />}
      title={t(`error.${kind}.title`)}
      description={t(`error.${kind}.body`)}
      footer={<LanguageSwitcher />}
    >
      {/* A full navigation, not a router transition: Traefik may have served
          this page for a URL that belongs to another app. */}
      <a href="/" className={buttonClassName} data-variant="primary" data-size="lg">
        {t('actions.backToSignIn', { ns: 'common' })}
      </a>
    </CenteredPage>
  );
}
